import { find } from "lodash"
import type { ReactNode } from "react"
import React from "react"

import type { Loading } from "@/lib/loading"
import { LoadingContext } from "@/lib/loading/context"
import { unloadedProcesses } from "@/lib/loading/unloadedProcesses"
import { ReactPerformance } from "@/lib/react_performance"

type Props = {
  children: ReactNode
}

type State = {
  processes: Loading.Processes
  ready: boolean
  update: boolean
}

export class LoadingContainer extends React.Component<Props, State> {
  public state: State = {
    processes: unloadedProcesses,
    ready: false,
    update: false,
  }

  public render = (): ReactNode => {
    return (
      <LoadingContext.Provider
        value={{
          processes: this.state.processes,
          ready: this.state.ready,
          update: this.update,
        }}
      >
        {this.props.children}
      </LoadingContext.Provider>
    )
  }

  public shouldComponentUpdate: ReactPerformance.Functions.ShouldComponentUpdate<
    Props,
    State
  > = ReactPerformance.curryShouldUpdateWithManagedState(
    this,
    ({ nextProps }) => {
      if (this.props.children !== nextProps.children) {
        return { update: true }
      }
    }
  )

  private update: Loading.Functions.Update = (processes) => {
    this.updateState((prevState: State) => {
      const result = { ...prevState.processes, ...processes }
      return {
        processes: result,
        ready: !find(result, ({ loading }) => {
          return loading
        }),
      }
    })
  }

  private updateState = ReactPerformance.curryUpdateManagedState(this)
}
